import { JSONObject } from 'module/types/common';
import { CommandProps, Editor } from '@tiptap/core';
import { Node } from '@tiptap/pm/model';

export enum AskAiCommand {
  EnhanceWithMyNotes = 'enhance-with-my-notes',
  MakeLonger = 'make-longer',
  MakeShorter = 'make-shorter',
}
type BaseAskAiRequestPayload = {
  content: JSONObject[];
  selection: {
    from: number;
    to: number;
  };
};
type MakeLongerRequestPayload = BaseAskAiRequestPayload & {
  command: AskAiCommand.MakeLonger;
};
type MakeShorterRequestPayload = BaseAskAiRequestPayload & {
  command: AskAiCommand.MakeShorter;
};
type EnhanceWithMyNotesRequestPayload = BaseAskAiRequestPayload & {
  command: AskAiCommand.EnhanceWithMyNotes;
  enhanceWithNotes: string;
};
export type AskAiRequestPayload =
  | MakeLongerRequestPayload
  | MakeShorterRequestPayload
  | EnhanceWithMyNotesRequestPayload;

export type ProcessAskAiRequestProps = {
  editor: Editor;
  payload: AskAiRequestPayload;
  onCancel: () => void;
  onComplete: (newContent: JSONObject[]) => void;
};
export type ContentReplacementOptions = {
  retainMetaForNode?: (node: Node) => boolean;
};

export interface AskAiCommandOptions {
  processAskAiRequest: (props: ProcessAskAiRequestProps) => void;
  contentReplacementOptions?: ContentReplacementOptions;
}
export type CustomCommand = (
  props: CommandProps & {
    options: AskAiCommandOptions;
  },
) => boolean;
